'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellBannerRootContext } from './context/upsell-banner-root.context';
import { upsellBannerBodyRecipe } from './styles/upsell-banner-body.styles';
import type { UpsellBannerBodyPropsInterface } from './types/upsell-banner-body.types';

/**
 * @since 10.0.0
 */
export const UpsellBannerBody = forwardRef<HTMLDivElement, UpsellBannerBodyPropsInterface>(
  (props: UpsellBannerBodyPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellBannerRootContext);
    const styles = css(upsellBannerBodyRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="UpsellBanner.Body"
        className={cx('c11n', 'c11n_upsell-banner__body', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellBannerBody.displayName = 'UpsellBanner.Body';
